import { useEffect } from 'react';
import { graphql, navigate } from 'gatsby';

const IndexPage = ({ data }: IndexPageProps) => {
  const { node_locale, slug } = data.contentfulCampaignConfiguration.mainHub;
  const targetSlug = `/${node_locale}/${slug === '/' ? '' : slug}`;

  useEffect(() => {
    void navigate(targetSlug);
  }, [targetSlug]);

  return null;
};

export const query = graphql`
  query ContentfulIndexPage($locale: String, $campaignKey: String) {
    contentfulCampaignConfiguration(
      node_locale: { eq: $locale }
      campaignKey: { eq: $campaignKey }
    ) {
      mainHub {
        node_locale
        slug
      }
    }
  }
`;

export type IndexPageProps = {
  data: {
    contentfulCampaignConfiguration: {
      mainHub: {
        node_locale: string;
        slug: string;
      };
    };
  };
};

export default IndexPage;
